import { combineReducers } from 'redux';
import mainReducer from '@gc-npm/reducers.main-reducer';
import modalsReducer from '@gc-npm/reducers.modals-reducer';
import headerReducer from '@gc-npm/reducers.header-reducer';
import autonomos from './autonomos';
// own
import clientReducer from './client';
import modulosReducer from './modules';
import UIReducer from './ui';
import cartReducer from './cart';
import devicesReducer from './devices';
import recomendatorReducer from './recomendator';

const rootReducers = () => combineReducers({
  main: mainReducer,
  header: headerReducer,
  modals: modalsReducer,
  autonomos,
  // own
  client: clientReducer,
  modulos: modulosReducer,
  UI: UIReducer,
  cart: cartReducer,
  devices: devicesReducer,
  recomendator: recomendatorReducer,
});

export default rootReducers;
